import { render } from "./TermsConditionAgreementForm.vue?vue&type=template&id=3673bca2&scoped=true"
import script from "./TermsConditionAgreementForm.vue?vue&type=script&lang=js"
export * from "./TermsConditionAgreementForm.vue?vue&type=script&lang=js"

import "./TermsConditionAgreementForm.vue?vue&type=style&index=0&id=3673bca2&scoped=true&lang=css"

import exportComponent from "../../../../../../../../var/www/html/fms_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3673bca2"]])

export default __exports__